<template>
  <div class="wrapper">
    <el-dialog :visible.sync="centerDialogVisible" title="微信支付" :close-on-click-modal="false" @close="closeDialog">
      <div class="box">
        <div class="l">
          <div class="text">
            请使用
            <span>微信</span>
            <i class="icon iconfont iconrichscan_icon"></i>
            <span>扫一扫</span>
          </div>
          <div class="text">扫描二维码支付</div>
          <div class="codeImg">
            <div id="qrcode" ref="qrcode"></div>
            <div class="tip">二维码有效时长为2小时，请尽快支付</div>
          </div>
        </div>
        <div class="r"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';
export default {
  name: "Payment",
  components: {},
  props: {
    codeImg:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      centerDialogVisible: true
    };
  },
  watch: {
  },
  computed: {},
  methods: {
    closeDialog(){
      this.$emit('clearInterPay')
    },
    qrcode () {
      let that=this;
      let qrcode = new QRCode('qrcode', {  
          width: 230,  
          height: 230,
          text: that.codeImg
      })  
    },
  },
  created() {},
  mounted() {
      this.$nextTick (function () {
        this.qrcode();
      })
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.wrapper {
  .box {
    display: flex;
    height: 500px;
    justify-content: space-around;
    padding: 50px;
    box-sizing: border-box;
    .l {
      width: 280px;
      text-align: center;
      .text {
        line-height: 1.5;
        span{
          color:#fe9717;
        }
        .icon{
          margin:0 5px;
          font-size: 14px;
        }
      }
      .codeImg {
        width: 280px;
        height: 280px;
        border: 1px solid $border;
        margin-top: 20px;
        position: relative;
        #qrcode{
          width: 230px;
          height: 230px;
          display: block;
          margin: 10px auto 0;
        }
        .tip {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 26px;
          line-height: 26px;
          background: $theme-bg;
          text-align: center;
          color: #fe9717;
        }
      }
    }
    .r {
      width: 235px;
      background: url("~@/assets/wechatsys.png") no-repeat center;
    }
  }
}
</style>